class BugReport {

    private _bugReportId: string;
    private _timestamp: Date;
    private _header: string;
    private _message: string;

    public constructor(bugReportId: string, timestamp: Date, header: string, message: string) {

        this._bugReportId = bugReportId;
        this._timestamp = timestamp;
        this._header = header;
        this._message = message;
    }

    public get bugReportId(): string {
        return this._bugReportId;
    }

    public set bugReportId(value: string) {
        this._bugReportId = value;
    }

    public get timestamp(): Date {
        return this._timestamp;
    }

    public set timestamp(value: Date) {
        this._timestamp = value;
    }

    public get header(): string {
        return this._header;
    }

    public set header(value: string) {
        this._header = value;
    }

    public get message(): string {
        return this._message;
    }

    public set message(value: string) {
        this._message = value;
    }
}

export default BugReport;